/* eslint-disable jsx-a11y/label-has-associated-control,jsx-a11y/label-has-for */
import React, { useContext } from 'react';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import { Button, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import CreditPolicyDetailContext from './CreditPolicyDetailContext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import {
  API,
  BASE_URL,
  TIPO_PLAN_CUOTAS_ID,
  TIPO_PLAN_LIBRO_VENTAS_ID,
  TIPO_PLAN_PLAN_PAGOS_ID,
  TIPO_INDEMNIZACION_MAXIMA_VECES_PRIMA_INICIAL_ID,
  TIPO_GESTIONES_PROPIAS_EMISION_ID,
} from '../../../CONST';

import { fileDownload, pluralize, roundFloat } from '../../../helpers/helpers';
import FormSection from '../../layout/FormSection';
import InfoSection from "components/shared/InfoSection";
import CreditPolicyDetailFiliales from '../../CreditPolicyDetailFiliales';
import CreditPolicyDetailBeneficiarios from '../../CreditPolicyDetailBeneficiarios';

const CreditPolicyDetailBasicInfo = ({policy, loginIdToken}) => {
  const { currentEndoso: balance } = useContext(CreditPolicyDetailContext);

  if (policy === null)
    return null;

  const base = policy.base;
  const polizaMaestra = base?.poliza_maestra;
  
  if (!base) {
    console.error('Base data not found in policy');
    return <div>Error: Base data not available</div>;
  }

  const currentBalance = balance || (policy.endosos && policy.endosos.length > 0 ? policy.endosos[0] : null);
  const note = '*Los datos mostrados corresponden a los valores de la vigencia seleccionada.';
  const {
    condiciones_parametrizadas: condicionesParametrizadas = [],
    condiciones_particulares: condicionesParticulares = [],
  } = currentBalance;
  
  return (
    <Col md={{ offset: 2, size: 8 }}>
      <InfoSection
        title={`Información básica - ${base.nemotecnico} (Vigencia: #${currentBalance.numero_vigencia || 'N/A'} Endoso: #${currentBalance.secuencia_endoso || '0'})`}
        note={note}
        style={{ marginTop: '70px' }}
        items={[
          {
            label: 'Nemotécnico',
            labelFor: 'nemotecnico',
            value: <p id="nemotecnico">{base.nemotecnico}</p>
          },
          {
            label: 'Ramo FECU',
            labelFor: 'ramo-fecu',
            value: <p id="ramo-fecu">{polizaMaestra?.ramo_asegurado?.descripcion || 'N/A'}</p>
          },
          {
            label: 'Moneda',
            labelFor: 'moneda',
            value: <p id="moneda">{base.moneda_asegurada?.descripcion || 'N/A'}</p>
          },
          {
            label: 'Condicionado general',
            labelFor: 'condicionado-general',
            value: (
              <p id="condicionado-general">
                {polizaMaestra?.url ? (
                  <>
                    <a
                      href={polizaMaestra.url}
                      target='_blank'
                      rel='noopener noreferrer'
                      style={{color: '#215797'}}
                    >
                      <u>{polizaMaestra.nemotecnico}</u>
                    </a>
                    <Button
                      title="Descargar"
                      className="form-values download"
                      onClick={() => fileDownload(
                        `${BASE_URL}${API.fullCreditos}/${policy.id}/download-maestra/`,
                        loginIdToken,
                        )}
                      style={{marginLeft: '10px'}}
                    >
                      <FontAwesomeIcon icon={faDownload} />
                    </Button>
                  </>
                ) : 'N/A'}
              </p>
            ) 
          },
          {
            label: 'Producto',
            labelFor: 'producto',
            value: <p id="producto">{base.producto?.descripcion || 'N/A'}</p>
          },
          {
            label: 'Tipo de cobertura',
            labelFor: 'tipo-cobertura',
            value: <p id="tipo-cobertura">{base.tipo_cobertura?.descripcion || 'N/A'}</p>
          },
          {
            label: 'Ejecución',
            labelFor: 'tipologia-ejecucion',
            value: <p id="tipologia-ejecucion">{base.tipologia_ejecucion?.descripcion || 'N/A'}</p>
          },
          {
            label: 'Tipo de intermediario',
            labelFor: 'tipo-intermediario',
            value: <p id="tipo-intermediario">{base.tipo_intermediario?.descripcion || 'N/A'}</p>
          },
          {
            label: 'Intermediario',
            labelFor: 'intermediario',
            value: (
              <p id="intermediario">
                {currentBalance.intermediario ? `${currentBalance.intermediario.rut} - ${currentBalance.intermediario.nombre}` : 'N/A'}
              </p>
            )
          },
          {
            label: 'Comisión',
            labelFor: 'comision',
            value: (
              <NumberFormat
                id="comision"
                name="tasaCostoSeguroDefectoPct"
                decimalSeparator=","
                decimalScale="2"
                fixedDecimalScale
                suffix="%"
                value={currentBalance.comision_pct || 0}
                displayType="text"
                renderText={(value) => <p>{value}</p>}
              />
            )
          },
          {
            label: 'Asegurado',
            labelFor: 'asegurado',
            value: (
              <p id="asegurado">
                {base.asegurado ? `${base.asegurado.rut} - ${base.asegurado.nombre}`: 'N/A'}
              </p>
            )
          },
        ]}
      />
      <InfoSection
        title="Detalles"
        note={note}
        style={{ marginTop: '20px' }}
        items={[
          {
            label: 'Inicio Vigencia Endoso',
            labelFor: 'inicio-vigencia-endosos',
            value: <p id="inicio-vigencia-endosos">{currentBalance.inicio_vigencia_endoso || 'N/A'}</p>
          },
          {
            label: 'Inicio Vigencia Póliza',
            labelFor: 'inicio-vigencia-poliza',
            value: <p id="inicio-vigencia-poliza">{currentBalance.inicio_vigencia || 'N/A'}</p>
          },
          {
            label: 'Fin de Vigencia',
            labelFor: 'fin-vigencia',
            value: <p id="fin-vigencia">{currentBalance.termino_vigencia || 'N/A'}</p>
          },
          {
            label: 'Estimación de Ventas',
            labelFor: 'estimacion-ventas',
            value: (
              <NumberFormat
                id="estimacion-ventas"
                name="estimacionVentasAmt"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale="2"
                fixedDecimalScale
                suffix={` ${base.moneda_asegurada?.nombre_corto || ''}`}
                value={currentBalance.estimacion_ventas_amt || 0}
                displayType="text"
                renderText={(value) => <p>{value}</p>}
              />
            )
          },
          {
            label: 'Tasa costo seguro',
            labelFor: 'tasa-costo-seguro-defecto',
            value: (
              <NumberFormat
                id="tasa-costo-seguro-defecto"
                name="tasaCostoSeguroDefectoPct"
                decimalSeparator=","
                decimalScale="3"
                fixedDecimalScale
                suffix="%"
                value={currentBalance.tasa_costo_seguro_defecto_pct || 0}
                displayType="text"
                renderText={(value) => <p>{value}</p>}
              />
            )
          },
          {
            label: 'Prima mínima mensual',
            labelFor: 'prima-minima-mensual',
            value: (
              <NumberFormat
                id="prima-minima-mensual"
                name="primaMinimaMensualAmt"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale="2"
                fixedDecimalScale
                suffix={` ${base.moneda_asegurada?.nombre_corto || ''}`}
                value={currentBalance.prima_minima_mensual_amt ? roundFloat(currentBalance.prima_minima_mensual_amt) : 0}
                displayType="text"
                renderText={(value) => <p>{value}</p>}
              />
            )
          },
          {
            label: 'Prima mínima anual',
            labelFor: 'prima-minima-anual',
            value: (
              <NumberFormat
                id="prima-minima-anual"
                name="primaMinimaAnualAmt"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale="2"
                fixedDecimalScale
                suffix={` ${base.moneda_asegurada.nombre_corto}`}
                value={currentBalance.prima_minima_anual_amt ? roundFloat(currentBalance.prima_minima_anual_amt) : 0}
                displayType="text"
                renderText={(value) => <p>{value}</p>}
              />
            )
          },
          {
            label: 'Plazo máximo de crédito',
            labelFor: 'plazo-maximo-credito',
            value: (
              <NumberFormat
                id="plazo-maximo-credito"
                name="plazoMaximoCredito"
                suffix=" días"
                value={currentBalance.plazo_maximo_credito_dias ? currentBalance.plazo_maximo_credito_dias : 0}
                displayType="text"
                renderText={(value) => <p>{value}</p>}
              />
            )
          },
          {
            label: 'Indemnización máxima',
            labelFor: 'indemnizacion-maxima',
            value: (
              <NumberFormat
                id="indemnizacion-maxima"
                name="indemnizacionMaxima"
                thousandSeparator="."
                decimalSeparator={
                  currentBalance.tipo_indemnizacion_max === TIPO_INDEMNIZACION_MAXIMA_VECES_PRIMA_INICIAL_ID
                    ? ''
                    : ','
                }
                decimalScale={
                  currentBalance.tipo_indemnizacion_max === TIPO_INDEMNIZACION_MAXIMA_VECES_PRIMA_INICIAL_ID
                    ? '0'
                    : '2'
                }
                fixedDecimalScale
                suffix={
                  currentBalance.tipo_indemnizacion_max === TIPO_INDEMNIZACION_MAXIMA_VECES_PRIMA_INICIAL_ID
                    ? ' veces la prima devengada'
                    : ` ${base.moneda_asegurada.nombre_corto}`
                }
                value={currentBalance.indemnizacion_max_amt}
                displayType="text"
                renderText={(value) => <p>{value}</p>}
              />
            )
          },
          {
            label: 'Forma de pago',
            labelFor: 'forma-pago',
            value: (
              <p id="forma-pago">
                {currentBalance.plan_pago.tipo === TIPO_PLAN_LIBRO_VENTAS_ID && 'Libro de Ventas'}
                {currentBalance.plan_pago.tipo === TIPO_PLAN_CUOTAS_ID &&
                  `En ${pluralize('cuota', currentBalance.plan_pago.cuotas)}`}
                {currentBalance.plan_pago.tipo === TIPO_PLAN_PLAN_PAGOS_ID && 'Plan de pago'}
              </p>
            )
          },
          {
            label: 'Configuración de siniestro',
            labelFor: 'configuracion-siniestro',
            value: (
              <NumberFormat
                id="configuracion-siniestro"
                name="confoiguracionSiniestro"
                suffix=" días"
                value={currentBalance.configuracion_siniestro_dias}
                displayType="text"
                renderText={(value) => <p>{value}</p>}
              />
            )
          },
          {
            label: 'Período de gestiones propias',
            labelFor: 'periodo-gestiones-propias',
            value: (
              <NumberFormat
                id="periodo-gestiones-propias"
                name="periodoGestionesPropias"
                suffix={
                  currentBalance.tipo_gestiones_propias === TIPO_GESTIONES_PROPIAS_EMISION_ID
                    ? ' días desde la emisión'
                    : ' días desde el vencimiento'
                }
                value={currentBalance.plazo_gestiones_propias_dias}
                displayType="text"
                renderText={(value) => <p>{value}</p>}
              />
            )
          },
          {
            label: 'Umbral',
            labelFor: 'umbral',
            value: (
              <NumberFormat
                id="umbral"
                name="umbral"
                decimalSeparator=","
                decimalScale="2"
                fixedDecimalScale
                suffix={` ${base.moneda_asegurada.nombre_corto}`}
                value={currentBalance.umbral_cobertura_amt}
                displayType="text"
                renderText={(value) => <p>{value}</p>}
              />
            )
          },
        ]}
      />
      <FormSection>
        <div className="row p-2 mb-2">
          <div className="col-md-6">
            <label htmlFor="filiales">Filiales</label>
            <CreditPolicyDetailFiliales
              filiales={currentBalance.clienteendoso_set?.filter(cli => cli.is_filial) || []}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="beneficiarios">Beneficiarios</label>
            <CreditPolicyDetailBeneficiarios
              beneficiarios={currentBalance.clienteendoso_set?.filter(cli => cli.is_beneficiario) || []}
            />
          </div>
        </div>
      </FormSection>
      <InfoSection
        title="Clientes nominados"
        note={note}
        style={{ marginTop: '40px' }}
        items={[
          {
            label: 'Cobertura',
            labelFor: 'cobertura-nominados',
            value: (
              <NumberFormat
                id="cobertura-nominados"
                name="coberturaNominados"
                decimalSeparator=","
                decimalScale="2"
                fixedDecimalScale
                suffix="%"
                value={currentBalance.cobertura_nominados_pct || 0}
                displayType="text"
                renderText={(value) => <p>{value}</p>}
              />
            )
          },
          {
            label: 'Costo de estudio',
            labelFor: 'costo-estudio-aprobado-nominados',
            value: (
              <>
                <NumberFormat
                  id="costo-estudio-aprobado-nominados"
                  name="costoEstudioAprobado"
                  decimalSeparator=","
                  decimalScale="2"
                  fixedDecimalScale
                  suffix={` ${base.moneda_asegurada.nombre_corto} clientes aprobados`}
                  value={currentBalance.costo_estudio_nominado_aprobado_amt || 0}
                  displayType="text"
                  renderText={(value) => (
                    <p>
                      {value}
                    </p>
                  )}
                />
                <NumberFormat
                  id="costo-estudio-rechazado-nominados"
                  name="costoEstudioRechazado"
                  decimalSeparator=","
                  decimalScale="2"
                  fixedDecimalScale
                  suffix={` ${base.moneda_asegurada.nombre_corto} clientes rechazados`}
                  value={currentBalance.costo_estudio_nominado_rechazado_amt || 0}
                  displayType="text"
                  renderText={(value) => <p>{value}</p>}
                />
              </>
            )
          },
        ]}
      />
      {currentBalance.clientes_innominados && (
        <InfoSection
          title="Clientes innominados"
          note={note}
          style={{ marginTop: '20px' }}
          items={[
            {
              label: 'Cobertura',
              labelFor: 'cobertura-innominados',
              value: (
                <NumberFormat
                  id="cobertura-innominados"
                  name="coberturaInnominados"
                  decimalSeparator=","
                  decimalScale="2"
                  fixedDecimalScale
                  suffix="%"
                  value={currentBalance.cobertura_innominados_pct || 0}
                  displayType="text"
                  renderText={(value) => <p>{value}</p>}
                />
              )
            },
            {
              label: 'Costo de estudio',
              labelFor: 'costo-estudio-aprobado-innominados',
              value: (
                <>
                  <NumberFormat
                    id="costo-estudio-aprobado-innominados"
                    name="costoEstudioAprobadoInnominado"
                    decimalSeparator=","
                    decimalScale="2"
                    fixedDecimalScale
                    suffix={` ${base.moneda_asegurada.nombre_corto} clientes aprobados`}
                    value={currentBalance.costo_estudio_innominado_aprobado_amt || 0}
                    displayType="text"
                    renderText={(value) => (
                      <p>
                        {value}
                      </p>
                    )}
                  />
                  <NumberFormat
                    id="costo-estudio-rechazado-innominados"
                    name="costoEstudioRechazadoInnominado"
                    decimalSeparator=","
                    decimalScale="2"
                    fixedDecimalScale
                    suffix={` ${base.moneda_asegurada.nombre_corto} clientes rechazados`}
                    value={currentBalance.costo_estudio_innominado_rechazado_amt || 0}
                    displayType="text"
                    renderText={(value) => <p>{value}</p>}
                  />
                </>
              )
            },
            {
              label: 'Monto máximo',
              labelFor: 'monto-maximo-innominados',
              value: (
                <NumberFormat
                  id="monto-maximo-innominados"
                  name="montoMaximoInnominados"
                  decimalSeparator=","
                  decimalScale="2"
                  fixedDecimalScale
                  suffix={` ${base.moneda_asegurada.nombre_corto}`}
                  value={currentBalance.maximo_innominados_amt || 0}
                  displayType="text"
                  renderText={(value) => <p>{value}</p>}
                />
              )
            },
            ...(currentBalance.tipo_indemnizacion_max === TIPO_INDEMNIZACION_MAXIMA_VECES_PRIMA_INICIAL_ID
              ? [
                  {
                    label: 'Indemnización máxima',
                    labelFor: 'indemnizacion-maxima-innominados',
                    value: (
                      <NumberFormat
                        id="indemnizacion-maxima-innominados"
                        name="indemnizacionMaximaInnominados"
                        suffix=" veces la prima devengada "
                        value={currentBalance.indemnizacion_max_innominado || 0}
                        displayType="text"
                        renderText={(value) => <p>{value}</p>}
                      />
                    ),
                  },
                ]
              : []),
          ]}
        />
      )}
      <InfoSection
        title="Condiciones"
        note={note}
        style={{ marginTop: '20px' }}
        items={[
          {
            label: 'Condiciones particulares',
            labelFor: 'condiciones_particulares',
            value: (
              <>
                {condicionesParticulares && condicionesParticulares.length > 0 ? (
                  condicionesParticulares.map((condicion, index) => (
                    <div key={index}>
                      <p className="small-form-value mb-0">{condicion.name}</p>
                      {index < condicionesParticulares.length - 1 && <hr className="my-1" />}
                    </div>
                  ))
                ) : (
                  <p className="small-form-value mb-0">Sin condiciones</p>
                )}
              </>
            )
          },
          {
            label: 'Cláusulas parametrizadas',
            labelFor: 'clausulas_parametrizadas',
            value: (
              <>
                {condicionesParametrizadas && condicionesParametrizadas.length > 0 ? (
                  condicionesParametrizadas.map((condicion, index) => (
                    <div key={index}>
                      <p className="small-form-value mb-0">{condicion.name}</p>
                      {index < condicionesParametrizadas.length - 1 && <hr className="my-1" />}
                    </div>
                  ))
                ) : (
                  <p className="small-form-value mb-0">Sin condiciones</p>
                )}
              </>
            )
          },
        ]}
      />
    </Col>
  )
};

CreditPolicyDetailBasicInfo.propTypes = {
  policy: PropTypes.shape({
    id: PropTypes.number.isRequired,
    balance: PropTypes.number,
    base: PropTypes.object,
    endosos: PropTypes.array,
  }),
  loginIdToken: PropTypes.string.isRequired,
};

CreditPolicyDetailBasicInfo.defaultProps = {
  policy: null,
};

const mapStateToProps = state => ({
  loginIdToken: state.login.id_token,
});

export default connect(mapStateToProps)(CreditPolicyDetailBasicInfo);
